(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-countdown"] && !Shopify.designMode) return;
  try {
    function initTippy() {
      tippy('.product-countdown', {
        placement: 'bottom'
      });
  }
  document.addEventListener('DOMContentLoaded', function() {
    initTippy();
  });
  subscribe(PUB_SUB_EVENTS.variantChange, initTippy);
  } catch(e) { console.error(e); }
})();

})();
